import Extend from 'flarum/common/extenders';
import Exhibition from './models/Exhibition';
import ExhibitionFinding from './models/ExhibitionFinding';
import Society from './models/Society';
import Toxicity from './models/Toxicity';
import CartothequeEntry from './models/CartothequeEntry';
export default [new Extend.Store().add('champis-exhibitions', Exhibition).add('champis-exhibitions-findings', ExhibitionFinding).add('champis-exhibitions-societies', Society).add('champis-exhibitions-toxicities', Toxicity).add('champis-exhibitions-cartotheque-entries', CartothequeEntry)];